import module from 'cliente/module.js'

const schema = {
  actividad_economica_id: 'number',
  giro_mercantil_id: 'number',
  escritura_fecha: 'date',
  escritura_numero: 'number',
  escritura_volumen: 'number',
  notaria_numero: 'number',
  inscripcion_fecha: 'date',
  estatus_id: 'number',
  socios: 'array',
}

export class ClienteInformacionJuridicoService {
  constructor ($http) {
    this.$http = $http
  }

  get (idCliente) {
    return this.$http.get('/kendu/clientes/cliente/informacion/juridico', {
      params: {idCliente: idCliente},
      cache: 'Cliente',
      schema,
    })
  }

  put (idCliente, data) {
    return this.$http.put('/kendu/clientes/cliente/informacion/juridico', data, {
      params: {idCliente: idCliente},
      clearCache: 'Cliente',
      schema,
    })
  }
}

module.service('ClienteInformacionJuridico', ClienteInformacionJuridicoService)



// WEBPACK FOOTER //
// ./src/cliente/services/Informacion/Juridico.js